import { asBoolean, asString, isObject } from "./model-utils";
import { enumValue, ProfileType } from "./enums";

export class Host {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.name = asString(json.name);
    this.handle = asString(json.handle);
    this.profileId = asString(json.profileId);
    this.image = asString(json.image);
    this.verified = asBoolean(json.verified);
    this.profileType = enumValue(ProfileType, json.profileType);
  }

  static fromJson(json: any) {
    return isObject(json) ? new Host(json) : json;
  }
}
